import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { SetLoginFlow } from '~/pages/unAuthorizedPages/LoginScreen/LoginScreen.types';
import { isObject } from '../isObject';
import { ErrorResponse } from './ErrorResponse';
export class LoginErrorResponse {
    loginFlow() {
        var _this_error_context;
        const loginType = (_this_error_context = this.error.context()) === null || _this_error_context === void 0 ? void 0 : _this_error_context.loginType;
        const setLoginFlows = Object.values(SetLoginFlow);
        return setLoginFlows.includes(loginType) ? loginType : null;
    }
    recipientEmail() {
        var _this_error_context;
        const recipientEmail = (_this_error_context = this.error.context()) === null || _this_error_context === void 0 ? void 0 : _this_error_context.recipientEmail;
        return typeof recipientEmail === 'string' ? recipientEmail : null;
    }
    isSharedProposalLinkFlow() {
        var _this_error_context;
        const loginFlow = (_this_error_context = this.error.context()) === null || _this_error_context === void 0 ? void 0 : _this_error_context.loginFlow;
        return isObject(loginFlow) && loginFlow.sharedProposalLink === true;
    }
    constructor(error){
        _define_property(this, "error", void 0);
        this.error = error instanceof ErrorResponse ? error : new ErrorResponse(error);
    }
}
